export const RESEARCH_EXPORT_SCHEMA = "stoptrading.research-export.v1";

export type ExportScalar = string | number | boolean | null | undefined;

function safeSpreadsheetText(value: string): string {
  return /^[=+\-@]/.test(value) ? `'${value}` : value;
}

function csvCell(value: ExportScalar): string {
  if (value === null || value === undefined) return "";
  const rendered =
    typeof value === "string"
      ? safeSpreadsheetText(value)
      : typeof value === "number"
        ? Number.isFinite(value)
          ? String(value)
          : ""
        : value
          ? "true"
          : "false";
  return `"${rendered.replace(/"/g, '""')}"`;
}

/** RFC 4180 rows with stable headers, CRLF and locale-neutral numbers. */
export function researchCSV(
  headers: readonly string[],
  rows: ReadonlyArray<Record<string, ExportScalar>>,
): string {
  const header = headers.map((value) => csvCell(value)).join(",");
  const body = rows.map((row) => headers.map((key) => csvCell(row[key])).join(","));
  return [header, ...body].join("\r\n") + "\r\n";
}

export interface ResearchExportManifest {
  schema: typeof RESEARCH_EXPORT_SCHEMA;
  generatedAt: string;
  timezone: "UTC";
  locale: string;
  scope: "run" | "comparison" | "workspace";
  omittedFields: string[];
  methodologyURL: string;
}

export interface ResearchJSONExport<T> {
  manifest: ResearchExportManifest;
  payload: T;
}

export function researchJSONExport<T>(
  payload: T,
  options: {
    locale: string;
    scope: ResearchExportManifest["scope"];
    omittedFields?: string[];
    generatedAt?: string;
  },
): string {
  const methodologyLocale = options.locale === "en"
    ? ""
    : `/${encodeURIComponent(options.locale)}`;
  const envelope: ResearchJSONExport<T> = {
    manifest: {
      schema: RESEARCH_EXPORT_SCHEMA,
      generatedAt: options.generatedAt ?? new Date().toISOString(),
      timezone: "UTC",
      locale: options.locale,
      scope: options.scope,
      omittedFields: [...new Set(options.omittedFields ?? [])].sort(),
      methodologyURL: `https://backtest.click${methodologyLocale}/methodology/`,
    },
    payload,
  };
  return JSON.stringify(envelope, null, 2) + "\n";
}
